module.exports = __webpack_public_path__ + "img/default-product-image.43226343.png";